<template>
  <div class="flex flex-wrap">
    <div
      class="img-item"
      v-for="i in data"
      :key="i.id"
    >
      <vs-button
        class="img-delete-button"
        radius
        color="danger"
        type="border"
        icon="delete"
        @click="confirmDelete(i.id)"
      ></vs-button>
      <transition name="fade">
        <img :src="i.imageUrl">
      </transition>
    </div>
    <div class="img-item">
      <div class="item-upload">
        <div class="icon-image-upload">
          <div class="upload-icon-wrapper">
            <feather-icon
              :title="$t('Upload Image')"
              icon="UploadIcon"
              class="upload-svg-icon text-white"
            ></feather-icon>
            <input
              type="file"
              @change="onFileChange"
              ref="file"
              multiple
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { uploadFile } from '@/api/storage'

export default {
  props: {
    listingId: {
      type: String,
      required: true,
    }
  },
  data () {
    return {
      idForDeletion: null
    }
  },
  methods: {
    confirmDelete (id) {
      this.idForDeletion = id
      this.showConfirmDeletion(this.deleteItem)
    },
    deleteItem () {
      this.$store.dispatch('businessPhoto/delete', this.idForDeletion)
        .catch(err => {
          this.notifyError(err.msg)
        })
        .then(() => this.notifySuccess('Image deleted'))
    },
    onFileChange () {
      var files = this.$refs.file.files

      if (files.length > 0) {
        this.$vs.notify({
          title: 'Warning',
          text: 'Uploading file...',
          color: 'warning',
          icon: 'cloud_upload'
        })
      }

      for (const file of files) {
        if (file) {
          var fileExtension = file.name.split('.')
          uploadFile(`upload/${this.filename}-${Date.now()}.${fileExtension.pop()}`, file)
            .then(snapshot => {
              return snapshot.ref.getDownloadURL()
                .then((res) => this.$store.dispatch('businessPhoto/insert', { imageUrl: res }))
            })
            .catch(err => {
              this.notifyError(err.msg)
            })
            .then(() => this.notifySuccess('Image uploaded'))
        }
      }

    }
  },
  computed: {
    data: {
      get () {
        return this.$store.getters['businessPhoto/arrayData']
      }
    }
  },
  mounted () {
    this.$store.dispatch('businessPhoto/fetchAndAdd', { businessId: this.listingId })
    this.isMounted = true
  },
  beforeDestroy() {
    this.$store.dispatch('businessPhoto/closeDBChannel', {clearModule: true})
  }
};
</script>


<style lang="scss">
.img-item {
  padding: 5px;
  position: relative;
  transition: all 0.5s;

  .img-delete-button {
    position: absolute;
    right: 15px;
    top: 15px;
    z-index: 1;
  }
  img {
    width: 100px;
    height: 100px;
    object-fit: cover;
    transition: all 0.3s ease;
  }

  &:hover img {
    filter: brightness(0.2);
    transition: all 0.3s ease;
  }
}

.item-upload {
  background-color: rgba(0, 0, 0, 0.5);
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon-image-upload {
  overflow: hidden;

  &:hover {
    cursor: pointer;
  }
  .upload-icon-wrapper {
    position: relative;
    overflow: hidden;
    width: 25px;
    height: 25px;

    &:hover {
      cursor: pointer;
    }
    .upload-svg-icon {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;

      &:hover {
        cursor: pointer;
      }
    }

    input {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      opacity: 0;

      &:hover {
        cursor: pointer;
      }
    }
  }
}
</style>
